export const RESOURCE_IS_LOADING = "RESOURCE_IS_LOADING";
export const RESOURCE_ITEMS_RECEIVED = "RESOURCE_ITEMS_RECEIVED";
export const RESOURCE_ITEM_RECEIVED = "RESOURCE_ITEM_RECEIVED";
export const RESOURCE_ACTION_RECEIVED = "RESOURCE_ACTION_RECEIVED";

export const resourceIsLoading = (resource) => ({
  type: RESOURCE_IS_LOADING,
  resource,
})

export const resourceItemsReceived = (resource, data) => ({
  type: RESOURCE_ITEMS_RECEIVED,
  resource,
  data,
})

export const resourceItemReceived = (resource, item) => ({
  type: RESOURCE_ITEM_RECEIVED,
  resource,
  item,
})

export const resourceActionReceived = (resource, action, data) => ({
  type: RESOURCE_ACTION_RECEIVED,
  resource,
  action,
  data,
})

export const crudInitialState = {};

export const crudReducer = (state, action) => {
  let newState = { ...state };
  switch (action.type) {
    case RESOURCE_IS_LOADING:
      newState[action.resource] = {
        ...state[action.resource],
        isLoading: true,
      };
      return newState;
    case RESOURCE_ITEMS_RECEIVED:
      newState[action.resource] = {
        ...state[action.resource],
        isLoading: false,
        count: action.data.count,
        previous: action.data.previous,
        next: action.data.next,
        items: action.data.results,
        itemsDate: new Date(),
      }
      return newState;
    case RESOURCE_ITEM_RECEIVED:
      newState[action.resource] = {
        ...state[action.resource],
        isLoading: false,
        item: action.item,
        itemDate: new Date(),
      };
      return newState;
    case RESOURCE_ACTION_RECEIVED:
      newState[action.resource] = {
        ...state[action.resource],
        isLoading: false,
        [action.action]: action.data,
        date: new Date(),
      };
      return newState;
    default:
      return state;
  }
}
